// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nodata-module--wrapper--1bRKY"};